import { useNavigate, useLocation, Outlet, useParams } from 'react-router'
import { useEffect } from 'react'

import { ROUTE_TRADER } from '@klear/constants'
import { useAuth } from '@klear/ui/contexts/auth-context'

const AuthLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { traderId } = useParams()
  const { user } = useAuth()

  useEffect(() => {
    if (user && !traderId) {
      const traderPrefix = `/${ROUTE_TRADER}`
      if (location.pathname === `${traderPrefix}/select-trader`) {
        return
      }

      if (user.hasKlearRole || user.traderIds.length > 1) {
        console.debug('redirecting to select trader')
        navigate(`${traderPrefix}/select-trader`, { replace: true })
      } else if (user.traderIds.length === 1) {
        console.debug('redirecting to trader', user.traderIds[0], location.pathname)
        const subPath = location.pathname.slice(traderPrefix.length)
        navigate(`${traderPrefix}/${user.traderIds[0]}${subPath}`, { replace: true })
      } else {
        console.debug('no urlTraderId?')
        navigate('/not-found', { replace: true })
      }
      return
    }
  }, [user, traderId, navigate, location.pathname])

  if (!user) {
    return null
  }

  return <Outlet />
}

export default AuthLayout
